function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* istanbul ignore file */

// TODO: Need to address coverage issues

import React, { useEffect, useMemo, useState } from 'react';
import { isBreakpointMediumOrAbove, useBreakpoint, withScopedBaseStyles } from '@noths/polaris-client-ribbons-base';
import { Drawer } from '@noths/polaris-client-ribbons-design-system';
import { DepartmentsNav } from "../../molecules/DepartmentsNav/DepartmentsNav";
import { NavigationDrilldown } from "../../molecules/NavigationDrilldown/components/NavigationDrilldown";
import { transformToDepartmentsProp } from "./transformToDepartmentsProp";
import { transformToDrilldownProp } from "./transformToDrilldownProp";
import { useSiteChromeDynamicContext } from "../../../context/SiteChromeDynamicContext/useSiteChromeDynamicContext";
import { useSiteChromeStaticContext } from "../../../context/SiteChromeStaticContext/useSiteChromeStaticContext";
var Component = function Component(_ref) {
  var content = _ref.content;
  var _useSiteChromeDynamic = useSiteChromeDynamicContext(),
    navigationModal = _useSiteChromeDynamic.navigationModal;
  var _useSiteChromeStaticC = useSiteChromeStaticContext(),
    useScopedStyles = _useSiteChromeStaticC.useScopedStyles;
  var onClose = function onClose() {
    return navigationModal === null || navigationModal === void 0 ? void 0 : navigationModal.close();
  };
  var breakpoint = useBreakpoint({
    initializeWithLarge: true
  });
  var isMediumScreenOrAbove = isBreakpointMediumOrAbove(breakpoint);
  var _useState = useState('partial'),
    _useState2 = _slicedToArray(_useState, 2),
    drawerSize = _useState2[0],
    setDrawerSize = _useState2[1];
  var departmentsNav = useMemo(function () {
    return transformToDepartmentsProp(content);
  }, [content]);
  var featuredDepartmentIndex = content.featured_l1_instance ? Number(content.featured_l1_instance) - 1 : -1;
  var drilldownNav = useMemo(function () {
    return transformToDrilldownProp(content);
  }, [content]);
  useEffect(function () {
    setDrawerSize(isMediumScreenOrAbove ? 'partial' : 'full');
  }, [isMediumScreenOrAbove]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DepartmentsNav, {
    departments: departmentsNav,
    featuredDepartmentIndex: featuredDepartmentIndex
  }), /*#__PURE__*/React.createElement(Drawer, {
    contentLabel: "Navigation",
    isOpen: !!(navigationModal !== null && navigationModal !== void 0 && navigationModal.isOpen),
    onRequestClose: onClose,
    panelSize: drawerSize,
    transitionFrom: "right",
    useScopedStyles: useScopedStyles
  }, /*#__PURE__*/React.createElement(NavigationDrilldown, {
    navigation: drilldownNav,
    onClose: onClose
  })));
};
export var Navigation = withScopedBaseStyles(Component);